import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";

// import { toggleSidebar } from "./GrapesJS/geditor/geditor_utils";
import PanelBasicActions from "./PanelBasicActions/PanelBasicActions.jsx";
import { setZoom } from "./GrapesJS/geditor/grapesjs_settings.js";

function TopNav({ pId, kmId, kmList, pType = "presentations" }) {
  let prevLink = "#",
    nextLink = "#",
    idx = 0;
  // console.log(kmList);
  if (pId && kmId && kmList.length > 1) {
    //if there is more than 1 slide, then make the prev, next buttons available
    idx = kmList.findIndex((km) => km._id === kmId);

    prevLink =
      idx !== 0
        ? `/${pType}/${pId}/key-messages/${kmList[idx - 1]._id}/edit`
        : null;
    nextLink =
      idx !== kmList.length - 1
        ? `/${pType}/${pId}/key-messages/${kmList[idx + 1]._id}/edit`
        : null;
  }
  // const handleClick = () => {
  //   toggleSidebar(false);
  // };

  const [isLeftSidebarOpen, setIsLeftSidebarOpen] = useState(true);
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(true);

  const handleToggleLeftSidebar = () => {
    const leftSidebar = document.querySelector("#navbar");
    const mainContent = document.querySelector("#main-content");
    const gjsEditor = document.querySelector("#main-content #gjs-editor");
    const topNav = document.querySelector("#main-content .navbar");

    if (!leftSidebar.classList.contains("d-none")) {
      topNav.classList.add("left-collapsed");
      leftSidebar.classList.add("d-none");
      mainContent.classList.remove("w-70", "w-85", "w-100", "start-15");
      mainContent.classList.add(isRightSidebarOpen ? "w-85" : "w-100");
      gjsEditor.classList.add("left-collapsed");
    } else {
      topNav.classList.remove("left-collapsed");
      leftSidebar.classList.remove("d-none");
      mainContent.classList.remove("w-70", "w-85", "w-100");
      mainContent.classList.add(isRightSidebarOpen ? "w-70" : "w-85", "start-15");
      gjsEditor.classList.remove("left-collapsed");
    }

    setTimeout(() => {
      window.editor.refresh();
      const currentZoom = localStorage.getItem('saved-zoom') ? localStorage.getItem('saved-zoom') : 80;
      setZoom(window.editor, currentZoom);
    }, 10);

    setIsLeftSidebarOpen((isLeftSidebarOpen) => !isLeftSidebarOpen);
  };

  const handleToggleRightSidebar = () => {
    const rightSidebar = document.querySelector("#right-sidenav");
    const mainContent = document.querySelector("#main-content");
    const topNav = document.querySelector("#main-content .navbar");

    if (!rightSidebar.classList.contains("d-none")) {
      // hide right side bar -> if left-open -> make main content w-85 -> else main content w-100
      topNav.classList.add("right-collapsed");
      rightSidebar.classList.add("d-none");
      mainContent.classList.remove("w-70", "w-85", "w-100");
      mainContent.classList.add(isLeftSidebarOpen ? "w-85" : "w-100");
    } else {
      // show right side bar -> if left-open -> make main content w-70 -> else main content w-85
      topNav.classList.remove("right-collapsed");
      rightSidebar.classList.remove("d-none");
      mainContent.classList.remove("w-70", "w-85", "w-100");
      mainContent.classList.add(isLeftSidebarOpen ? "w-70" : "w-85");
    }

    setTimeout(() => {
      window.editor.refresh();
      const currentZoom = localStorage.getItem('saved-zoom') ? localStorage.getItem('saved-zoom') : 80;
      setZoom(window.editor, currentZoom);
    }, 10);

    setIsRightSidebarOpen((isRightSidebarOpen) => !isRightSidebarOpen);
  };

  return (
    <nav className="navbar navbar-light">
      <div className="container">
        <button
          className="btn btn-sm btn-outline-primary br-0 fw-bold"
          onClick={handleToggleLeftSidebar}
          title="Toggle left sidebar"
        >
          {isLeftSidebarOpen ? "<<" : ">>"}
          {/* <i className="fa fa-bars"></i> */}
        </button>
        {/* slide navigation buttons */}
        {pId && kmId && (
          <div className="gjs-pn-panel d-inline-flex">
            {/* previous button */}
            {idx !== 0 ? (
              <NavLink
                reloadDocument
                to={prevLink}
                className="btn btn-sm btn-outline-primary mx-1 br-0"
                title="Previous Key Message"
              >
                <i className="fa fa-arrow-left"></i>
              </NavLink>
            ) : (
              <button
                className="btn btn-sm btn-outline-primary mx-1 disabled br-0"
                disabled
                title="Previous Key Message"
              >
                <i className="fa fa-arrow-left"></i>
              </button>
            )}
            {/* next button */}
            {idx !== kmList.length - 1 ? (
              <NavLink
                reloadDocument
                to={nextLink}
                className="btn btn-sm btn-outline-primary mx-1 br-0"
                title="Next Key Message"
              >
                <i className="fa fa-arrow-right"></i>
              </NavLink>
            ) : (
              <button
                className="btn btn-sm btn-outline-primary mx-1 disabled br-0"
                disabled
                title="Next Key Message"
              >
                <i className="fa fa-arrow-right"></i>
              </button>
            )}

            {/* slide list dropdown */}
            <Dropdown>
              <Dropdown.Toggle
                style={{ height: "100%" }}
                className="btn btn-sm btn-outline-primary mx-1 br-0"
                id="dropdown-button-dark-example1"
              >
                <i className="fa fa-list"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {kmList
                  ? kmList.map((km) => {
                      let link = `/${pType}/${pId}/key-messages/${km._id}/edit`;
                      return (
                        <Dropdown.Item
                          key={km._id}
                          href={link}
                          active={km._id === kmId}
                        >
                          {km.name}
                        </Dropdown.Item>
                      );
                    })
                  : ""}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
        <div className="panel__devices"></div>
        <div className="panel__editor"></div>
        <div className="zoom">80%</div>
        <PanelBasicActions />
        <div id="show-changes-count"></div>
        <button
          className="btn btn-sm btn-outline-primary br-0 ms-2 fw-bold"
          onClick={handleToggleRightSidebar}
          title="Toggle right sidebar"
        >
          {/* <i className="fa fa-bars" /> */}
          {isRightSidebarOpen ? ">>" : "<<"}
        </button>
      </div>
    </nav>
  );
}

export default TopNav;
